import React from 'react';
import PropTypes from 'prop-types';
import { TableHead, TableRow, TableCell } from '@mui/material';
import { styled } from '@mui/system';

const HeadCell = styled(TableCell)({
  textAlign: 'center',
  fontSize: 'var(--xtram-panel-cell, 12px) !important',
});

/* שמות עמודות */
const BASE_COLUMNS = [
  'Actions',
  'caseNumber',
  'Client Name',
  'ClientId',
  'phoneNumber',
  'TaxAssessor',
  'SubAccountant',
  'DeductionsCase',
  'EconomicBusinessBranch',
];

// ManageOnly clients hide both tax-authority columns (no reporting workflow exposed).
const TAX_AUTHORITY_COLUMNS = [
  'WithholdingTaxApprovalValidity',
  'TaxAuthorityLoginValidity',
];

const ClientDataTableHead = ({ t, isManageOnly = false }) => {
  const columns = isManageOnly
    ? BASE_COLUMNS
    : [...BASE_COLUMNS, ...TAX_AUTHORITY_COLUMNS];
  return (
    <TableHead>
      <TableRow>
        {columns.map((col) => (
          <HeadCell key={col}>
            {t(col)}
          </HeadCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

ClientDataTableHead.propTypes = {
  t: PropTypes.func.isRequired,
  isManageOnly: PropTypes.bool,
};

export default ClientDataTableHead;
